import { SolicitudCompaniaTenantService } from "services";
import { ResponseExceptionHandlerHelper } from "utils";

export const SolicitudCompaniaTenantManager = (() => {
  const { handleException } = ResponseExceptionHandlerHelper();

  const buscarSolicitudCompaniaTenantPorId = (request) => {
    return SolicitudCompaniaTenantService.buscarSolicitudCompaniaTenantPorId(request).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const listarSolicitudes = (where) => {
    return SolicitudCompaniaTenantService.listarSolicitudes(where).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const crearCompaniaVinculada = (solicitud) => {
    return SolicitudCompaniaTenantService.crearCompaniaVinculada(solicitud).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const reactivarCompaniVinculada = (solicitud) => {
    return SolicitudCompaniaTenantService.reactivarCompaniVinculada(solicitud).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const actualizarSolicitudCompaniaTenant = (solicitud) => {
    return SolicitudCompaniaTenantService.actualizarSolicitudCompaniaTenant(solicitud).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const bloquearCancelarCompania = (solicitud) => {
    return SolicitudCompaniaTenantService.bloquearCancelarCompania(solicitud).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  return {
    buscarSolicitudCompaniaTenantPorId,
    listarSolicitudes,
    crearCompaniaVinculada,
    reactivarCompaniVinculada,
    actualizarSolicitudCompaniaTenant,
    bloquearCancelarCompania
  }
})();